export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl -translate-y-1/3 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/30 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4"></div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-6">
              <i className="ri-fire-line text-sm"></i>
              <span>国产动漫精品入口</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight mb-4">
              51动漫官网
              <br />
              <span className="text-primary-500">国产动漫爱好者首选平台</span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              51动漫官网作为国内领先的动漫资源聚合导航平台，汇集海量51动漫网与51动漫网站优质国产动漫资源，为动漫爱好者提供一站式官方直达入口。无论是最新番剧、经典国漫还是热门剧场版，都可以通过51动漫主页快速找到并开始观看。
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              平台持续追踪国内动漫更新动态，收录超过数千部国产动漫作品，每日实时更新番剧进度。当前正值国漫暑期档，多部热门动漫同步热播中，为漫迷带来不间断的视觉盛宴。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500">3000+</div>
                <div className="text-xs text-foreground-500 mt-1">收录动漫作品</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">番剧追更保障</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500">安全直达</div>
                <div className="text-xs text-foreground-500 mt-1">官方认证入口</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-rocket-2-line text-lg"></i>
                立即探索热门动漫
              </a>
              <a
                href="#carousel"
                className="inline-flex items-center gap-2 px-8 py-3 border-2 border-primary-200 text-primary-600 font-semibold rounded-full hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-compass-3-line text-lg"></i>
                查看焦点专题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[380px] sm:w-[340px] sm:h-[440px] md:w-[400px] md:h-[520px] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20vibrant%20anime-style%20illustration%20featuring%20a%20dynamic%20character%20in%20a%20colorful%20fantasy%20world%20with%20glowing%20energy%20effects%2C%20warm%20orange%20and%20golden%20lighting%2C%20dramatic%20composition%2C%20clean%20modern%20anime%20art%20style%2C%20rich%20details%20with%20flowing%20hair%20and%20heroic%20pose%2C%20vibrant%20red%20and%20amber%20accents%2C%20epic%20atmosphere%2C%20high%20quality%20illustration&width=800&height=1040&seq=hero-anime-51dm&orientation=portrait"
                alt="51动漫官网主视觉 - 动漫角色插画"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}